import React from "react";
import styled from "styled-components";
export const Avatar = ({
  src = "",
  alt = "",
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Image, props, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};
const Image = styled.div`
  display: flex;
  flex-shrink: 0;
  border-radius: 50%;
  user-select: none;
  overflow: hidden;
  width: 104px;
  height: 104px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;